import { render, staticRenderFns } from "./closeAction.vue?vue&type=template&id=167fba76"
import script from "./closeAction.vue?vue&type=script&lang=js"
export * from "./closeAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports